<div class="container">
  <div class="form-section">
    <h3 class="mb-3">Get Listed</h3>

    <!-- Success/Error Message -->
    @if (message) {
      <div class="alert alert-dismissible fade show" [class.alert-success]="messageType === 'success'"
        [class.alert-danger]="messageType === 'error'" role="alert">
        {{ message }}
        <button type="button" class="btn-close" (click)="message = ''" aria-label="Close"></button>
      </div>
    }

    <!-- Registration Form -->
    <form id="registrationForm" (ngSubmit)="onSubmit($event)" #regForm="ngForm">
      <!-- WhatsApp Number -->
      <div class="mb-3">
        <label for="whatsapp" class="form-label">
          WhatsApp Number
          <small class="text-muted">(Include country code e.g., +1 for US)</small>
        </label>
        <div class="input-group">
          <span class="input-group-text bg-success text-white">
            <i class="fab fa-whatsapp"></i>
          </span>
          <input type="tel" class="form-control" id="whatsapp" name="whatsapp"
            [(ngModel)]="registrationData.whatsapp" placeholder="+1234567890" pattern="^\+\d{10,15}$"
            required>
        </div>
      </div>

      <!-- Company Name -->
      <div class="mb-3">
        <label for="companyName" class="form-label">Company Name</label>
        <input type="text" class="form-control" id="companyName" name="companyName"
          [(ngModel)]="registrationData.name" placeholder="TrucksToHire" required>
      </div>

      <!-- Website Address -->
      <div class="mb-3">
        <label for="website" class="form-label">Website Address</label>
        <input type="url" class="form-control" id="website" name="website"
          [(ngModel)]="registrationData.website" placeholder="https://truckstohire.com" pattern="https?://.+"
          required>
      </div>

      <!-- Logo URL -->
      <div class="mb-3">
        <label for="logo" class="form-label">
          Logo URL
          <small class="text-muted">(Optional)</small>
        </label>
        <input type="url" class="form-control" id="logo" name="logo" [(ngModel)]="registrationData.logo"
          placeholder="https://example.com/logo.png">
          <!-- Logo Preview -->
          @if (registrationData.logo) {
            <div class="mt-2">
              <img [src]="registrationData.logo" alt="Logo preview" class="img-thumbnail"
                style="max-height: 60px;" (error)="onLogoPreviewError($event)">
            </div>
          }
        </div>

        <!-- Policy Acceptance Checkbox -->
        <div class="mb-3 form-check">
          <input type="checkbox" class="form-check-input" id="acceptPolicy" name="acceptPolicy"
            [(ngModel)]="registrationData.acceptPolicy" required>
          <label class="form-check-label small" for="acceptPolicy">
            I accept the <a href="/terms" class="text-decoration-none">Terms</a>
          </label>
        </div>

        <!-- Submit Button -->
        <div class="d-grid gap-2">
          <button type="submit" class="btn btn-dark py-2" [disabled]="loading || !regForm.valid">
            @if (loading) {
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            }
            @if (!loading) {
              <i class="fab fa-stripe me-2"></i>
            }
            {{ loading ? 'Registering...' : 'Register' }}
          </button>
        </div>

        <div class="text-center mt-3">
          <small class="text-muted">Registration is free till 01/01/2026</small>
        </div>
      </form>
    </div>
  </div>